import { Moment } from 'moment';
import {
	getPortById,
	getPortByName,
} from '@api/utils/ports';
import getUtcOffsetForLocation from './getUtcOffsetForLocation';

// Will default to UTC (0) if cannot find port
// date will be used to handle DST
const getPortUtcOffset = (
	portNameOrId: number | string | null | undefined,
	date?: Moment | Date | string,
): number => {
	if (portNameOrId == null) {
		return 0;
	}

	const port = typeof portNameOrId === 'string' ?
		getPortByName(portNameOrId) :
		getPortById(portNameOrId);

	if (port == null) {
		return 0;
	}

	return getUtcOffsetForLocation(port.timezone, date);
};

export default getPortUtcOffset;
